import styled, { keyframes } from "styled-components";

const blink = keyframes`
  50% { opacity: 0; }
`;

export const WidgetWrapper = styled.div`
  position: fixed;
  bottom: 24px;
  right: 24px;
  z-index: 9999;
`;

export const WidgetFab = styled.button`
  width: 56px;
  height: 56px;
  border-radius: 50%;
  border: none;
  background: ${props => props.theme.primaryColor || '#91B846'};
  color: white;
  cursor: pointer;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    opacity: 0.9;
  }

  svg {
    width: 28px;
    height: 28px;
  }
`;

export const WidgetContainer = styled.div`
  width: 440px;
  max-width: calc(100vw - 48px);
  height: 600px;
  max-height: calc(100vh - 80px);
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

export const HeaderContainer = styled.div`
  padding: 12px 16px;
  background: ${props => props.theme.primaryColor || '#91B846'};
  color: white;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const HeaderTitleGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const HeaderStatusDot = styled.span`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #fff;
  display: inline-block;
`;

export const HeaderMainTitle = styled.div`
  font-weight: 600;
`;

export const HeaderActions = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const HeaderResetButton = styled.button`
  border: 1px solid rgba(255, 255, 255, 0.5);
  background: rgba(255, 255, 255, 0.1);
  color: #fff;
  border-radius: 999px;
  padding: 4px 10px;
  font-size: 12px;
  cursor: pointer;

  &:hover {
    background: rgba(255, 255, 255, 0.2);
  }
`;

export const HeaderCloseButton = styled.button`
  background: none;
  border: none;
  color: inherit;
  cursor: pointer;
  padding: 6px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    background: rgba(255, 255, 255, 0.2);
  }

  svg {
    width: 20px;
    height: 20px;
  }
`;

export const MessagesContainer = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const MessageRow = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 85%;
  align-self: ${(props) => (props.isBot ? "flex-start" : "flex-end")};
`;

export const MessageBubble = styled.div`
  padding: 10px 14px;
  border-radius: 16px;
  font-size: 14px;
  line-height: 1.4;
  background: ${(props) => (props.isBot ? "#f0f0f0" : props.theme.primaryColor || '#91B846')};
  color: ${(props) => (props.isBot ? "#333" : "white")};
`;

export const TypingDot = styled.span`
  animation: ${blink} 1s infinite;
`;

export const MessageFigureWrapButton = styled.button`
  margin-top: 8px;
  border-radius: 8px;
  overflow: hidden;
  max-width: 100%;
  background: #f5f5f5;
  padding: 0;
  border: none;
  cursor: zoom-in;
  display: block;

  &:hover {
    opacity: 0.95;
  }
`;

export const MessageFigureImage = styled.img`
  display: block;
  max-width: 100%;
  height: auto;
  vertical-align: middle;
`;

export const MessageImagePreviewOverlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.55);
  z-index: 10001;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
`;

export const MessageImagePreviewContent = styled.div`
  position: relative;
  width: min(860px, 92vw);
  max-height: 90vh;
  border-radius: 10px;
  overflow: hidden;
  background: #fff;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.3);
`;

export const MessageImagePreviewCloseButton = styled.button`
  position: absolute;
  top: 8px;
  right: 8px;
  width: 28px;
  height: 28px;
  border: none;
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.65);
  color: #fff;
  font-size: 13px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const MessageImagePreviewImg = styled.img`
  display: block;
  width: 100%;
  height: auto;
  max-height: 86vh;
  object-fit: contain;
  background: #f4f4f4;
`;

export const MessageSourcesText = styled.div`
  margin-top: 6px;
  font-size: 12px;
  color: #666;
`;

/** Same pattern as Machines → Attachments document tiles: `<a href={url} download>`. */
export const SourceAnchor = styled.a`
  margin-right: 6px;
  padding: 0;
  border: none;
  background: none;
  font: inherit;
  font-size: inherit;
  color: #1a73e8;
  text-decoration: underline;
  cursor: pointer;
  text-align: left;

  &:hover {
    text-decoration: underline;
  }
`;

export const SourceUnavailableText = styled.span`
  margin-right: 6px;
  font: inherit;
  font-size: inherit;
  color: #5f6368;
`;

export const QuickActionsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  padding: 8px 16px;
`;

export const QuickActionButton = styled.button`
  padding: 6px 12px;
  font-size: 12px;
  border-radius: 16px;
  border: 1px solid #ddd;
  background: #fff;
  cursor: pointer;

  &:hover:not(:disabled) {
    background: #f5f5f5;
  }
`;

export const InputContainer = styled.div`
  padding: 12px 16px;
  border-top: 1px solid #eee;
  display: flex;
  gap: 8px;
`;

export const InputField = styled.input`
  flex: 1;
  padding: 10px 14px;
  border: 1px solid #ddd;
  border-radius: 20px;
  font-size: 14px;
`;

export const SendButton = styled.button`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: none;
  background: ${props => props.theme.primaryColor || '#91B846'};
  color: white;
  cursor: pointer;
  font-size: 16px;
`;
